(function() {
    const getVariantFromUrl = (url) => {
        if (!url) return null;
        const match = url.match(/variant=(\d+)/);
        return match ? match[1] : null;
    };

    document.addEventListener('click', function(e) {
        const btn = e.target.closest('.custom__btn-main');
        if (!btn) return;

        e.preventDefault();

        const card = btn.closest('.card-product');
        const activeSwatch = card ? card.querySelector('.swatch-button.active') : null;

        let variantId;

        if (activeSwatch && activeSwatch.getAttribute('data-link')) {
            variantId = getVariantFromUrl(activeSwatch.getAttribute('data-link'));
        }

        if (!variantId) {
            variantId = btn.getAttribute('data-product');
        }

        if (!variantId) return;

        const btnSpan = btn.querySelector('span');
        const originalText = btnSpan ? btnSpan.innerText : btn.innerText;

        // lock + loading
        btn.style.pointerEvents = 'none';
        btn.classList.add('loading');

        const sectionsToRequest = ['cart-drawer', 'cart-icon-bubble'];

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                id: parseInt(variantId),
                quantity: 1,
                sections: sectionsToRequest
            })
        })
            .then(response => {
                if (!response.ok) throw new Error('ATC failed');
                return response.json();
            })
            .then(parsedState => {
                const cartDrawer = document.querySelector('cart-drawer');
                if (cartDrawer) {
                    const drawerInner = cartDrawer.querySelector('.drawer__inner');
                    if (drawerInner) drawerInner.classList.remove('is-empty');
                    cartDrawer.classList.remove('is-empty');
                    cartDrawer.renderContents(parsedState);
                }

                btn.classList.remove('loading');
                btn.style.pointerEvents = 'auto';
            })
            .catch(error => {
                console.error('ATC Error:', error);

                // show error text
                if (btnSpan) btnSpan.innerText = 'ERROR';
                else btn.innerText = 'ERROR';

                btn.classList.remove('loading');

                setTimeout(() => {
                    if (btnSpan) btnSpan.innerText = originalText;
                    else btn.innerText = originalText;

                    btn.style.pointerEvents = 'auto';
                }, 2000);
            });
    });
})();
